import { dateFormat } from 'common/helpers/dateHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

import { requiresShipping } from '../../helpers';

const Shipping = (props) => {
  const { cart, currentStep, onEdit, settings } = props;

  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('shipping');
  };
  if (!requiresShipping(cart)) {
    return null;
  }
  if (currentStep === 'payment' || currentStep === 'complete') {
    return (
      <>
        <div>
          <div>
            <div>Shipping method</div>
            <div>
              <div className="shipping-method-row">
                {cart.shipping[0].title}
                {renderShippingPrice(cart.shipping[0], settings)}
              </div>
            </div>
          </div>
          <a href="#" aria-label="Edit shipping method" onClick={handleEdit}>
            Edit
          </a>
        </div>
        {renderDeliveryDate(cart, settings, handleEdit)}
      </>
    );
  }
  return null;
};

const renderDeliveryDate = (cart, settings, handleEdit) => {
  if (
    cart.selectedShippingOptions &&
    cart.selectedShippingOptions.requestedDeliveryDate
  ) {
    return (
      <>
        <div>
          <div>
            <div>Delivery date:</div>
            <div>
              {dateFormat(
                cart.selectedShippingOptions.requestedDeliveryDate,
                settings
              )}
            </div>
          </div>
          <a href="#" aria-label="Edit delivery date" onClick={handleEdit}>
            Edit
          </a>
        </div>
      </>
    );
  }
  return null;
};

const renderShippingPrice = (shipping, settings) => {
  if (shipping.originalPrice > shipping.price) {
    return (
      <span className="c7-checkout__content__summary__shipping-price">
        <span>{currencyFormat(shipping.originalPrice, settings)}</span>
        {currencyFormat(shipping.price, settings)}
      </span>
    );
  }
  return (
    <span className="c7-checkout__content__summary__shipping-price">
      {currencyFormat(shipping.price, settings)}
    </span>
  );
};

export default Shipping;
